<template>
	<div class="layout-topbar">
		<router-link to="/" class="layout-topbar-logo">
			<!-- <img alt="Logo" :src="darkTheme ? require(`@/assets/layout/images/wilmar-logo.png@`) : '@/assets/layout/images/wilmar-logo.png'" /> -->
			<img alt="Logo" :src="'/assets/layout/images/wilmar-logo.png'" />
			<span>PES</span>
			<sup style="font-size: 7pt; font-weight: bold;color: blue;">&nbsp;&nbsp;[{{ this.$store.getters.getServer
			}}]</sup>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" v-styleclass="{
			selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
		}">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<li>
				<div class="layout-topbar-button topbar-display-name">
					{{ this.displayName }}
					<br />
					{{ this.username }}
					<Divider layout="vertical" />
				</div>
			</li>
			<!-- <li>
				<button class="p-link layout-topbar-button" @click="toggleChangelog">
					<i class="pi pi-list"></i>
					<span style="display:none">Changelog</span>
				</button>
			</li> -->
			<li>
				<a v-bind:href="ExportForm" target="_blank" class="p-link layout-topbar-button"
					v-tooltip.bottom="'Form Manual'">
					<i class="pi pi-file-excel p-text-secondary" style="font-size: 1.5rem" v-badge="'Form'"></i>
				</a>
			</li>
			<li v-if="this.$store.getters.getAccount != this.$ACCOUNT.USER">
				<button class="p-link layout-topbar-button" @click="toggleGuide" v-tooltip.bottom="'Manual Guide'">
					<i class="pi pi-file p-text-secondary" v-badge="'Guide'"></i>
					<Menu ref="guideMenu" :model="guideItems" :popup="true" />
				</button>
			</li>
			<li v-else>
				<a v-bind:href="ExportGuideUser" target="_blank" class="p-link layout-topbar-button"
					v-tooltip.bottom="'Manual Guide'">
					<i class="pi pi-file-pdf p-text-secondary" style="font-size: 1.5rem" v-badge="'Guide'"></i>
				</a>
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="toggleLanguage" v-tooltip.bottom="'Language'">
					<i class="pi pi-globe p-text-secondary" v-badge="badgeLang"></i>
					<span>Language</span>

					<Menu ref="languageMenu" :model="languageItems" :popup="true" />
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button" @click="toggle" v-tooltip.bottom="'Settings'">
					<i class="pi pi-cog"></i>
					<span style="display:none">Settings</span>
					<Menu ref="menu" :model="items" :popup="true" />
				</button>
			</li>
		</ul>
	</div>

	<ChangePassword v-if="changePassword" :isVisible="changePassword" :userId="username" :requireCurrentPassword="true"
		@hide="hideChangePasswordDialog" @block-ui="blockUI" @unblock-ui="unblockUI" />
</template>

<script>
export default {
	data() {
		return {
			username: this.$store.getters.getUsername,
			changePassword: false
		}
	},
	methods: {
		hideChangePasswordDialog(event) {
			this.changePassword = false;
			this.errormessage = "";

			if (event && event.success) {
				this.$toast.add({ severity: 'success', summary: "Success", detail: event.message, life: 120000 });
			}
		},
		blockUI() {
			this.$emit("block-ui");
		},
		unblockUI() {
			this.$emit("unblock-ui");
		},
		onMenuToggle(event) {
			this.$emit('menu-toggle', event);
		},
		toggle(event) {
			this.$refs.menu.toggle(event);
		},
		toggleLanguage(event) {
			this.$refs.languageMenu.toggle(event);
		},
		toggleGuide(event) {
			this.$refs.guideMenu.toggle(event);
		},
		logout() {
			//this.$emit('block-ui');

			// this.$axios.defaults.headers.common["Authorization"] = null;
			// this.$store.dispatch("logout");

			this.$router.push({ name: "Logout", params: { sessionExpired: "N" } });
		},
		changeLanguage(lang) {
			var self = this;
			self.$emit("block-ui");
			this.$axios.post(this.$API_URL + "util/change_language", { language: lang })
				.then((response) => {
					self.$root.$i18n.locale = lang;
					self.$axios.defaults.headers.common["language"] = lang;
					self.$store.dispatch("language", lang);
					self.$emit("unblock-ui");
					// console.log(response);
				})
				.catch(function (err) {
					//console.log(err);
					self.$emit("unblock-ui");
				})

		},
		readNotif() {
			//Send API to Flag all Read
		},
		toggleChangelog() {
			this.$emit('toggle-changelog');
		},
	},
	computed: {
		darkTheme() {
			return this.$appState.theme.startsWith('saga');
		},
		lang() {
			return this.$store.getters.getLanguage
		},
		badgeLang() {
			return (this.$store.getters.getLanguage).toUpperCase();
		},
		username() {
			return this.$store.getters.getUsername;
		},
		displayName() {
			return this.$store.getters.getFullname;
		},
		picName() {
			return this.$store.getters.getPICname;
		},
		languageItems() {
			return [
				{
					label: '(EN) English',
					icon: this.lang == "en" ? 'pi pi-check' : "",
					command: () => {
						this.changeLanguage('en');
					}
				},
				{
					label: '(ID) Indonesia',
					icon: this.lang == "id" ? 'pi pi-check' : "",
					command: () => {
						this.changeLanguage('id');
					}
				}
			];
		},
		guideItems() {
			return [
				{
					label: 'Admin Unit',
					icon: 'pi pi-file-pdf',
					url: this.$API_URL.replace('/api', '') + 'PES/Manual Guide Admin.pdf',
					target: "_blank"
				},
				{
					label: 'OU HEAD',
					icon: 'pi pi-file-pdf',
					url: this.$API_URL.replace('/api', '') + 'PES/Manual Guide OU HEAD.pdf',
					target: "_blank"
				},
				{
					label: 'User',
					icon: 'pi pi-file-pdf',
					url: this.$API_URL.replace('/api', '') + 'PES/Manual Guide User.pdf',
					target: "_blank"
				}
			];
		},
		items() {
			var dataItems = [
				{
					label: 'Logout',
					icon: 'pi pi-fw pi-power-off',
					command: () => {
						this.logout();
					}
				}
			];

			if (!this.$store.getters.getUseAD) {
				dataItems.unshift(
					{
						label: 'Change Password',
						icon: 'pi pi-fw pi-lock',
						command: () => {
							this.changePassword = true;
						}
					}
				)
			}

			return dataItems;
		},
		ExportGuideUser() {
			return this.$API_URL.replace('/api', '') + 'PES/Manual Guide User.pdf';
		},
		ExportForm() {
			return this.$API_URL.replace('/api', '') + 'PES/Form Performance Appraisal.xlsx';
		}
	}
}
</script>